<pr-button
  [display]="display"
  [clazz]="clazz"
  [display]="display"
  [variant]="variant"
  [size]="size"
  [icon]="icon"
  [iconViewBoxWidth]="iconViewBoxWidth"
  [iconViewBoxHeight]="iconViewBoxHeight"
  (onClick)="open()"
  [tooltip]="tooltip"
  [label]="label"
  [rightIcon]="rightIcon"
  [leftIcon]="leftIcon"
></pr-button>
<pr-modal-confirm
  [display]="displayConfirm ? displayConfirm : display"
  [displayOptionnal]="displayOptionnal"
  [icon]="modalIcon ? modalIcon : icon"
  [title]="title"
  [comment]="comment"
  [labelConfirm]="labelConfirm"
  [labelCancel]="labelCancel"
  [optionnalLabel]="optionnalLabel"
  (onConfirm)="confirm()"
  (onConfirmOptionnal)="optionnalConfirm()"
>
  <ng-content></ng-content>
</pr-modal-confirm>
